import React, { Component } from "react";
import "./styles.css";
import Image from "../../../components/utils/Image";

export default function ChatList({ chats, userId, active, onSelectChat }) {
  return (
    <div className="chat-list-container">
      {chats.map(chat => {
        let profile = {};
        if (userId === chat.customerId._id) {
          profile = chat.professionalId;
        } else {
          profile = chat.customerId;
        }

        let isItMyMessage = chat.lastMessage.userId === userId;

        return (
          <button
            key={chat.currentConsultId._id}
            className={`chat-item ${active &&
              active.currentConsultId._id === chat.currentConsultId._id &&
              "active"}`}
            onClick={() => onSelectChat(chat)}
          >
            <Image
              src={profile.profilePhoto}
              fallbackSrc={
                "https://www.pngkit.com/png/detail/301-3012694_account-user-profile-avatar-comments-fa-user-circle.png"
              }
              alt={profile.firstName}
            />
            <div className="chat-item-info">
              <strong>
                {profile.firstName} {profile.lastName}
              </strong>
              <p>
                {chat.lastMessage &&
                  (isItMyMessage
                    ? `Você: ${
                        chat.lastMessage.text
                          ? chat.lastMessage.text.substring(0, 20)
                          : "Imagem"
                      }`
                    : chat.lastMessage.text
                    ? chat.lastMessage.text.substring(0, 25)
                    : "Imagem")}
              </p>
            </div>
          </button>
        );
      })}
    </div>
  );
}
